import { render, staticRenderFns } from "./op-assembly-order.vue?vue&type=template&id=1386e1ca&scoped=true&"
import script from "./op-assembly-order.vue?vue&type=script&lang=js&"
export * from "./op-assembly-order.vue?vue&type=script&lang=js&"
import style0 from "./op-assembly-order.vue?vue&type=style&index=0&id=1386e1ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386e1ca",
  null
  
)

export default component.exports